<ng-container *ngIf="(featureFlagsEnum.CopilotSearch | isFeatureFlagEnabled | async); else conpanySearch">
    <app-copilot-search-input 
        [(ngModel)]="searchText"
        [exampleSearches]="exampleSearches"
        [isLoading]="isLoading$ | async" 
        (searchTriggered)="onCopilotSearch()">
    </app-copilot-search-input>
</ng-container>
<ng-template #conpanySearch>
    <app-chips-input-form-field-ui 
        label="Company Name or Domain" 
        placeholder="Type Company Name or Domain"
        [showSearch]="true" 
        [showSearchPulseAnim]="true"
        class="no-padding pb-1"
        [(ngModel)]="welcomeCompany"
        (triggerSearch)="onSearchCompany()">
    </app-chips-input-form-field-ui>
</ng-template>